import { Tooltip } from 'react-tooltip';
import { createPortal } from 'react-dom';

const RetentionTooltipContent = () => (
  <>
    <p className='mb-2 text-[12px] leading-[150%]'>
      ICONIQ seeks to maintain the security, confidentiality, and anonymity of
      our users' data. The below outlines how we intend to collect and handle
      data, seeking to ensure a safe and secure experience while using Compass.
    </p>
    <p className='text-[12px] leading-[150%]'>Data Collection</p>
    <p className='mb-2 text-[12px] leading-[150%]'>
      We collect data from users of Compass to provide our services effectively.
      By entering your data, you consent to the retention and use by ICONIQ of
      your answers for future use. Your data will be handled securely and if any
      data is included in materials that are publicly available, such data is
      expected to be aggregated or/and anonymized. All collected data is stored
      in our secure databases in a table isolated from our other systems and
      unauthorized staff. Users can also opt out of providing any identifying
      information like company name / website.
    </p>
    <p className='text-[12px] leading-[150%]'>
      Data Analysis and Confidentiality
    </p>
    <p className='text-[12px] leading-[150%]'>
      All analysis performed on user data and presented to our users is expected
      to be based on aggregated statistical results. We generally follow the
      principle of "minimum aggregation," aiming to ensure that no statistic is
      revealed unless it satisfies the minimum n-size of 8 datapoints. For
      example, we would typically only show a median value for a metric like net
      dollar retention with 8 or more datapoints. This approach prevents the
      identification of individual users or companies through their data.
    </p>
  </>
);

const RetentionTooltip = () => {
  return createPortal(
    <Tooltip
      className='max-w-[585px] z-[200] !opacity-100 !text-gray-850 !bg-white text-start !p-3 !rounded-lg shadow-retention-tooltip'
      id='retention_tooltip'
      place='top'
    >
      <RetentionTooltipContent />
    </Tooltip>,
    document.body
  );
};

export default RetentionTooltip;
